/* eslint-disable @typescript-eslint/unbound-method */
import { ILockable } from "apps-module/app/shared-library/mixins/lock.mixin";
import "reflect-metadata";
import {Subscription} from "rxjs";

export const Pending = (target: ILockable, propertyKey: string | symbol): any => {
    const propertyType = Reflect.getMetadata("design:type", target, propertyKey);

    if (propertyType !== Subscription) {
        throw new Error("@Pending can be applied to Subscription type only");
    }

    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKey) || { enumerable: true, configurable: true };

    let value: Subscription;

    const originalGet = descriptor.get || ((): any => value);
    const originalSet = descriptor.set || ((val: Subscription): void => { value = val; });

    descriptor.get = originalGet;

    descriptor.set = function setProperty(val: Subscription): void {
        const self = this as ILockable;

        originalSet(val);
        value = val;
        self.lock();
        value.add(() => {
            self.unlock();
        });
    };

    return descriptor;
};
